<div class="slug-field">
  <app-input
    [type]="'text'"
    [formGroup]="form()"
    [controlName]="controlName()"
    [label]="'E-mail do Data Room'"
    [placeholder]="'nome-da-empresa'"
    [tooltipText]="tooltip"
    [loading]="checking()"
    [required]="false" />

  @if (status() && !status()!.available && !isEmpty) {
    <small class="slug-field__hint slug-field__hint--error">{{ status()!.message }}</small>
  } @else {
    <small class="slug-field__hint">{{ isEmpty ? 'Vazio: usa o CNPJ' : suffix }}</small>
  }
</div>
